import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

// Components

import DocumentOverride from './DocumentOverride';

// Utils

import { checkIfAllDocumentsProvided } from '@utils/miscellaneous/getVerificationDocumentsConfig';

// Constants

import { dashboardModalTypes } from '@constants/individualPortal/dashboard/modals/dashboardModalTypes';
import { configs } from '@constants/configs/configs';
import { UPLOADED_DOCUMENT_STATUSES } from '@constants/common/miscellaneous';



const CategoryHeader = props => {

    const {
        applicantEventId,
        applicantInfo,
        caseNumber,
        categoryType,
        documents,
        documentsQty,
        event,
        idx,
        mandatoryDocuments,
        overrideDone,
        parentActions: {
            handleResponse,
            overrideDocuments,
            showModal,
            updateMockData
        },
        receivedDocumentTypes,
        stateCode,
        userRole,
        validationCompleted
    } = props;

    const handleOverrideClick = categoryType => {

        const categoryMatchIndex = documents.findIndex(c => c.categoryType === categoryType);

        let updatedDocuments = [ ...documents ];

        if(~categoryMatchIndex) {
            updatedDocuments[categoryMatchIndex] = {
                ...documents[categoryMatchIndex],
                overrideDone: true
            };
        } else {
            updatedDocuments = [
                ...updatedDocuments,
                {
                    categoryType,
                    overrideDone: true
                }
            ];
        }

        const allDocumentsAreProvided = checkIfAllDocumentsProvided(stateCode, event, updatedDocuments);

        showModal({
            modalType: dashboardModalTypes.OVERRIDE_COMMENT_MODAL,
            modalData: {
                applicantInfo,
                override: overrideComment => {
                    if(configs.ENV.DEVELOPMENT) {
                        updateMockData(
                            'override',
                            [ applicantEventId, categoryType, overrideComment ]
                        );
                    } else {
                        overrideDocuments({
                            applicantEventId,
                            caseNumber,
                            categoryType,
                            overrideComment,
                            validationCompleted: allDocumentsAreProvided
                        }).then(res => handleResponse(res));
                    }
                }
            }
        });
    };

    const getCategoryStatus = () => {

        const labelConfig = {
            waived: {
                textId: 'qle.common.requirement_waived',
                className: 'waived'
            },
            completed: {
                textId: 'qle.common.completed',
                className: 'completed'
            },
            pending: {
                textId: 'qle.common.pending',
                className: 'pending'
            }
        };

        const checkIfNotSubmitted = () => {
            return !receivedDocumentTypes
                .some(dt => dt.documentStatus === UPLOADED_DOCUMENT_STATUSES.SUBMITTED);
        };

        let label = { textId: '', className: '' };
        switch(true) {
            case overrideDone:
                label = labelConfig.waived;
                break;
            case validationCompleted && !overrideDone && checkIfNotSubmitted():
                label = labelConfig.completed;
                break;
            case validationCompleted && !overrideDone:
                label = labelConfig.pending;
                break;
        }

        const {
            textId,
            className
        } = label;

        return (
            textId ?
                <span
                    id = 'qle-category-status'
                    className = { `pull-right category_status category_status--${ className }` }
                >
                    <FormattedMessage id = { textId }/>
                </span>:
                null
        );
    };

    const mandatoryDocumentsNlsValues = useMemo(() => ({
        documentsQty,
        mandatoryDocuments: mandatoryDocuments.length,
        mandatoryDocumentsList: (
            mandatoryDocuments.reduce((list, md, idx, arr) => {
                return [
                    ...list,
                    <FormattedMessage
                        key={md}
                        id={`qle.document.${md}`}
                    />,
                    ...(arr.length - idx > 1 ? [', '] : [])
                ];
            }, [])
        )
    }), [ documentsQty, mandatoryDocuments ]);

    return (
        <div id = 'qle-category-header' className = 'qle-category__header qle-content-area'>
            <div className="qle-content-area--left qle-category__header__name">{ idx + 1 }. </div>
            <div className="qle-content-area--right">
                <div className='qle-category__header__name required-true'>
                    <FormattedMessage id={`qle.category.${categoryType}`} />
                </div>
                <br/>
                <FormattedMessage
                    id = 'qle.category.appendix'
                    values={ mandatoryDocumentsNlsValues }
                />
            </div>
            <div>
                <DocumentOverride
                    {...{
                        categoryType,
                        handleOverrideClick,
                        receivedDocumentTypes,
                        overrideDone,
                        userRole
                    }}
                />
            </div>
            <div>{ getCategoryStatus() }</div>
        </div>
    );
};

export default CategoryHeader;